import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgModule,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import {DxTreeViewComponent, DxTreeViewModule} from 'devextreme-angular';

import * as events from 'devextreme/events';
import DevExpress from "devextreme";
import ItemClickEvent = DevExpress.ui.dxAccordion.ItemClickEvent;
import InitializedEvent = DevExpress.ui.dxMenu.InitializedEvent;

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, {static: true}) public menu?: DxTreeViewComponent;

  @Output()
  public selectedItemChanged = new EventEmitter<ItemClickEvent>();

  @Output()
  public openMenu = new EventEmitter<any>();

  @Input()
  public items: any[] = [];

  @Input()
  set selectedItem(value: string) {
    if (this.menu?.instance) {
      this.menu.instance.selectItem(value);
    }
  }

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }

  set compactMode(val) {
    this._compactMode = val;
    if (val && this.menu?.instance) {
      this.menu.instance.collapseAll();
    }
  }

  constructor(private elementRef: ElementRef) {
  }

  //TODO FIX
  public updateSelection(event: any) {
    const nodeClass = 'dx-treeview-node';
    const selectedClass = 'dx-state-selected';
    const leafNodeClass = 'dx-treeview-node-is-leaf';
    const element: HTMLElement = event.element;

    const rootNodes = element.querySelectorAll(`.${nodeClass}:not(.${leafNodeClass})`);
    Array.from(rootNodes).forEach(node => {
      node.classList.remove(selectedClass);
    });

    let selectedNode = element.querySelector(`.${nodeClass}.${selectedClass}`);
    while (selectedNode && selectedNode.parentElement) {
      if (selectedNode.classList.contains(nodeClass)) {
        selectedNode.classList.add(selectedClass);
      }

      selectedNode = selectedNode.parentElement;
    }
  }

  public onItemClick(event: ItemClickEvent) {
    if (event.itemData.hiddenInMobile) {
      alert('This view can\'t be opened in a mobile device.');
      return;
    }
    this.selectedItemChanged.emit(event);
  }

  public onMenuInitialized(event: InitializedEvent) {
    event?.component?.option('deferRendering', false);
  }

  public ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e: Event) => {
      this.openMenu.next(e);
    });
  }

  public ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }
}

@NgModule({
  imports: [DxTreeViewModule],
  declarations: [SideNavigationMenuComponent],
  exports: [SideNavigationMenuComponent]
})
export class SideNavigationMenuModule {
}
